import FieldType from '../../components/Form/Fields/type'
import { emailRequired, lengthRequired } from '@polvo-labs/form-utils'
import Password from '../../components/Form/Fields/Password'

export interface LoginFormData {
  email: string
  password: string
}

export type LoginForm = keyof LoginFormData

const fields: FieldType<LoginForm>[] = [
  {
    name: 'email',
    data: {
      icon: 'mail',
      label: 'E-mail',
    },
    validation: emailRequired,
    html: {
      maxLength: 255,
      placeholder: 'nome@email.com',
    },
  },
  {
    name: 'password',
    component: Password,
    data: {
      icon: 'password',
      label: 'Senha',
    },
    html: {
      maxLength: 255,
      placeholder: 'Digite sua senha',
    },
    validation: lengthRequired({ min: 6, max: 255 }),
  },
]

export default fields
